import React, { useState } from "react";
import { Shield, Mail, Lock, Eye, EyeOff, ArrowRight } from "lucide-react";
import initEmojiVideo from "../../../assets/init-emoji.mp4";
import okEmojiVideo from "../../../assets/ok-emoji.mp4";

const LoginCard = ({
  email,
  setEmail,
  password,
  setPassword,
  emailError,
  passError,
  loading,
  loginSuccess,
  onSubmit,
  onForgotPassword,
  onLoginVideoEnd,
  ip,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const showStatusIcon = loading || loginSuccess;

  return (
    <div className="login-card-wrap">
      <div className="login-mobile-brand">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
          alt="Aptitude Migration"
          width={56}
          height="auto"
        />
        <p>Aptitude Migration</p>
      </div>

      <div className="login-card">
        <div className="login-card-header">
          <div
            className={`login-card-icon${showStatusIcon ? " login-card-icon--active" : ""}`}
          >
            {showStatusIcon ? (
              <video
                key={loginSuccess ? "success" : "processing"}
                className="login-card-icon-video"
                src={loginSuccess ? okEmojiVideo : initEmojiVideo}
                autoPlay
                loop={!loginSuccess}
                muted
                playsInline
                onEnded={loginSuccess ? onLoginVideoEnd : undefined}
                aria-hidden="true"
              />
            ) : (
              <Shield size={28} strokeWidth={1.75} />
            )}
          </div>
          <h2 className="login-card-title">Welcome Back</h2>
          <p className="login-card-subtitle">Sign in to continue to your dashboard</p>
        </div>

        <form action="" onSubmit={onSubmit} noValidate>
          <div className="login-field">
            <div className="login-input-wrap">
              <Mail className="login-input-icon" strokeWidth={1.75} />
              <input
                className="login-input"
                type="email"
                name="email"
                value={email}
                id="email"
                placeholder="Enter your email"
                autoComplete="on"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {emailError && <p className="login-field-error">{emailError}</p>}
          </div>

          <div className="login-field">
            <div className="login-input-wrap">
              <Lock className="login-input-icon" strokeWidth={1.75} />
              <input
                className="login-input login-input--password"
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                placeholder="Enter your password"
                autoComplete="on"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="login-toggle-pw"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  <EyeOff size={18} strokeWidth={1.75} />
                ) : (
                  <Eye size={18} strokeWidth={1.75} />
                )}
              </button>
            </div>
            {passError && <p className="login-field-error">{passError}</p>}
          </div>

          <div className="login-options">
            <button type="button" className="login-forgot-btn" onClick={onForgotPassword}>
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            disabled={loading || loginSuccess}
            className="login-submit-btn"
          >
            {loading || loginSuccess ? "Signing in..." : "Sign In"}
            {!loading && !loginSuccess && <ArrowRight size={18} strokeWidth={2} />}
          </button>
        </form>

        {ip?.IPv4 && (
          <p className="login-ip-info">
            Your IP address {ip.IPv4}
            {(ip.city || ip.country_name) && (
              <> · {ip.city} {ip.country_name} {ip.country_code}</>
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoginCard;
